import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatDateRangePicker } from '@angular/material/datepicker';

@Component({
  selector: 'app-custom-date-range-picker',
  templateUrl: './custom-date-range-picker.component.html',
  styleUrls: ['./custom-date-range-picker.component.scss']
})
export class CustomDateRangePickerComponent {
  @Input() startDate: Date = new Date(new Date().setDate(new Date().getDate() - 10));
  @Input() endDate: Date = new Date();
  maxDate: Date = new Date();
  @Output() dateRangeChange = new EventEmitter<{start: Date, end: Date}>();

  @ViewChild('picker') picker!: MatDateRangePicker<Date>;

  get formattedRange(): string {
    if (!this.startDate || !this.endDate) return 'Select Date Range';
    const start = this.formatDate(this.startDate);
    const end = this.formatDate(this.endDate);
    return `${start} - ${end}`;
  }

  formatDate(date: Date): string {
    const d = new Date(date);
    const month = '' + (d.getMonth() + 1);
    const day = '' + d.getDate();
    const year = d.getFullYear();
    return [month.padStart(2, '0'), day.padStart(2, '0'), year].join('/');
  }

  onDateChange(event: any, type: 'start' | 'end') {
    if (type === 'start') {
      this.startDate = event.value;
    } else {
      this.endDate = event.value;
    }

    if (this.startDate && this.endDate) {
      this.dateRangeChange.emit({ start: this.startDate, end: this.endDate });
    }
  }

  openPicker() {
    this.picker.open();
  }
}
